import React, { useEffect, useState } from "react";
import ErrorIcon from "@mui/icons-material/Error";

type NewlyAddedBadgeProps = {
  className?: string;
  show?: boolean;
  size?: "small" | "medium" | "large";
};

const NewlyAddedBadge = ({
  className,
  show = true,
  size = "medium",
}: NewlyAddedBadgeProps) => {
  const [shouldAnimate, setShouldAnimate] = useState(false);

  useEffect(() => {
    if (show) {
      setShouldAnimate(true);
    }
  }, [show]);

  const scaleUpKeyframes = `
    @keyframes scaleUp {
      0% { transform: scale(0) rotate(0deg); }
      70% { transform: scale(1.2) rotate(10deg); }
      100% { transform: scale(1) rotate(0deg); }
    }
  `;

  return (
    <>
      <style dangerouslySetInnerHTML={{ __html: scaleUpKeyframes }} />
      <ErrorIcon
        fontSize={size}
        className={`bg-white text-purple-400 rounded-full ${className} ${show ? "visible" : "invisible"}`}
        style={{
          animation:
            shouldAnimate && show
              ? "scaleUp 0.4s ease-out forwards"
              : undefined,
        }}
      />
    </>
  );
};

export default NewlyAddedBadge;

type NewlyAddedBadgeWrapperProps = NewlyAddedBadgeProps & {
  children: React.ReactNode;
  placement?: "top-left" | "top-right";
};

const NewlyAddedBadgeWrapper = ({
  children,
  show = true,
  placement = "top-right",
  size,
}: NewlyAddedBadgeWrapperProps) => {
  const getPositionClasses = () => {
    switch (placement) {
      case "top-right":
        return "absolute top-0 right-0 transform translate-x-1/2 -translate-y-1/2";
      case "top-left":
      default:
        return "absolute top-0 left-0 transform -translate-x-1/2 -translate-y-1/2";
    }
  };

  return (
    <div className="relative">
      <NewlyAddedBadge
        show={show}
        size={size}
        className={getPositionClasses()}
      />
      {children}
    </div>
  );
};

export { NewlyAddedBadgeWrapper };
